import React from 'react';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { ButtonToolbar, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

const getBsStyle = (input, value) => ((input === value) ? 'success' : 'primary');
/* Example of date filter for date range but with days not hardcoded like the dateFilterRadios.
  {
    dateFilterRadios({
      handleOnClick: this.fetchSalesInvoiceByDetails,
      setFromDate: this.setFromDate,
      setToDate: this.setToDate,
      FromDate: this.state.FromDate,
      ToDate: this.state.ToDate,
      Days: this.state.Days,
    })
  }
*/

const customizableDateFilterRadios = props => (
  <ButtonToolbar className="radio-filter-buttons">
    <Button bsStyle={getBsStyle(props.userTimeSelection, '0')} style={{ width: '150px' }}>
      <div className="radio">
        <label htmlFor="thisMonth-radio-filter10">
          <input
            {...props.input}
            id="thisMonth-radio-filter10"
            type="radio"
            name="customizableDateFilterRadios"
            value="0"
            checked={(props.userTimeSelection === '0' || props.userTimeSelection === 0) && (props.userDays !== -1 || props.userDays !== '-1')}
            onChange={() => { props.handleOnClick('0'); }}
          />
            <Translate value="current_month" />
          {/* <Translate value="today" /> */}
        </label>
      </div>
    </Button>
    <Button bsStyle={getBsStyle(props.userTimeSelection, '1')} style={{ width: '150px' }}>
      <div className="radio">
        <label htmlFor="LastMonth-radio-filter10">
          <input
            {...props.input}
            id="LastMonth-radio-filter10"
            type="radio"
            name="customizableDateFilterRadios"
            value="1"
            checked={(props.userTimeSelection === '1' || props.userTimeSelection === 1) && (props.userDays !== -1 || props.userDays !== '-1')}
            onChange={() => { props.handleOnClick('1'); }}
          />
            <Translate value="last_month" />
          {/* <Translate value="today" /> */}
        </label>
      </div>
    </Button>
    <Button bsStyle={getBsStyle(props.userTimeSelection, '2')} style={{ width: '130px' }}>
      <div className="radio">
        <label htmlFor="sevenDay-radio-filter10">
          <input
            {...props.input}
            id="sevenDay-radio-filter10"
            type="radio"
            name="customizableDateFilterRadios"
            value="2"
            checked={(props.userTimeSelection === '2' || props.userTimeSelection === 2) && (props.userDays !== -1 || props.userDays !== '-1')}
            onChange={() => { props.handleOnClick('2'); }}
          />
            <Translate value="2_month" />
          {/* <Translate value="days" /> */}
        </label>
      </div>
    </Button>
    <Button bsStyle={getBsStyle(props.userTimeSelection, '3')} style={{ width: '130px' }}>
      <div className="radio">
        <label htmlFor="thirtyDay-radio-filter10">
          <input
            {...props.input}
            id="thirtyDay-radio-filter10"
            type="radio"
            name="customizableDateFilterRadios"
            value="3"
            checked={(props.userTimeSelection === '3' || props.userTimeSelection === 3) && (props.userDays !== -1 || props.userDays !== '-1')}
            onChange={() => { props.handleOnClick('3'); }}
          />
            <Translate value="3_month" />
          {/* <Translate value="days" /> */}
        </label>
      </div>
    </Button>
    <Button bsStyle={getBsStyle(props.userTimeSelection, -1)} style={{ width: '130px' }}>
      <div className="radio">
        <label htmlFor="dateRange-radio-filter10">
          <input
            {...props.input}
            id="dateRange-radio-filter10"
            type="radio"
            name="customizableDateFilterRadios"
            value="-1"
            checked={(props.userTimeSelection === '-1' || props.userTimeSelection === -1)}
            onChange={() => { props.userSetToRangeSearch(); }}
          />
          <Translate value="date_range" />
        </label>
      </div>
    </Button>
    <Button
      bsStyle="primary"
      disabled={props.userDays !== '-1' && props.userDays !== -1}
    >
      <label htmlFor="dateRange-radio-filter10">
        <DateTimePicker
          id="from-datepicker1"
          format="MM-DD-YY"
          className="test-rw-input"
          onChange={(e) => { props.userSetFromDate(e); }}
          time={false}
          placeholder="Start"
          disabled={props.userDays !== '-1' && props.userDays !== -1}
          value={props.userFromDate}
        />
      </label>
    </Button>

    <Button
      bsStyle="primary"
      disabled={props.userDays !== '-1' && props.userDays !== -1}
    >
      <label htmlFor="dateRange-radio-filter10">
        <DateTimePicker
          id="to-datepicker1"
          format="MM-DD-YY"
          className="test-rw-input"
          onChange={(e) => { props.userSetToDate(e); }}
          time={false}
          placeholder="End"
          disabled={props.userDays !== '-1' && props.userDays !== -1}
          value={props.userToDate}
        />
      </label>
    </Button>

    <Button
      className="search-button"
      bsStyle="primary"
      disabled={(props.userDays !== '-1' && props.userDays !== -1) || !props.userToDate || !props.userFromDate}
      onClick={() => { props.handleOnClick('-1'); }}
    >
      <em className="fa fa-search" />
    </Button>
  </ButtonToolbar>
);

customizableDateFilterRadios.propTypes = {
  input: React.PropTypes.node.isRequired,
  handleOnClick: React.PropTypes.func.isRequired,
  setFromDate: React.PropTypes.func.isRequired,
  setToDate: React.PropTypes.func.isRequired,
  FromDate: React.PropTypes.string.isRequired,
  ToDate: React.PropTypes.string.isRequired,
  userDays: React.PropTypes.string.isRequired,
  setToRangeSearch: React.PropTypes.func.isRequired,
};

export default customizableDateFilterRadios;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/customizableDateFilterRadios.jsx